<div class="row form-control-sec">

    <h4 class="title_css_doa">Search</h4>



    <div [formGroup]=frmInvoice *ngIf="frmInvoice">

        <div class="row">
            <div *ngFor="let field of DOA_Datafieldlist" [ngSwitch]="field.control_type"
                class="col-lg-{{field.control_type=='TEXTAREA'?6:3}}">
                <mat-form-field *ngSwitchCase="'TEXTBOX'" [style.width.%]="100">
                    <mat-label>
                        {{ field.field_name }}
                        <span *ngIf="field.is_mandatory == 1" class="field-mandatory">*</span>
                        <span *ngIf="field.validation_type == 'NUMERIC' &&  field.precision_point<=0"
                            class="field-numeric">#</span>
                        <span
                            *ngIf="(field.validation_type == 'NUMERIC' || field.validation_type == 'AMOUNT') &&  field.precision_point>0 "
                            class="field-decimal">##</span>
                    </mat-label>

                    <input matInput *ngIf="field.value_type=='text' && field.validation_type != 'AMOUNT'"
                        [type]="field.value_type" [formControlName]="field.db_column_name"
                        (keydown.enter)="submitInvoice()" (change)="changeTextFieldValue(field)"
                        (keypress)="omit_special_char($event,field.valid_input_regexp);" />

                    <input matInput *ngIf="field.value_type=='number'" class="text-end"
                        (keypress)="onTextBoxKeyPressEvent($event,field)" [type]="field.value_type"
                        [formControlName]="field.db_column_name" (keydown.enter)="submitInvoice()"
                        (change)="changeTextFieldValue(field)"
                        (keypress)="omit_special_char($event,field.valid_input_regexp);" />

                    <input matInput *ngIf="field.validation_type == 'AMOUNT'" class="text-end"
                        (blur)="commonService.formatCurrencyValue($event)" [type]="field.value_type"
                        [formControlName]="field.db_column_name" (keydown.enter)="submitInvoice()"
                        (change)="changeTextFieldValue(field)"
                        (keypress)="omit_special_char($event,field.valid_input_regexp);" />

                    <button *ngIf="field.is_magnify_search == 1" mat-button matSuffix mat-icon-button
                        (click)="openAdvanceSearchModal(field.field_mapping_detail_id,field.magnify_dependant_fields,field.predefined_table_column_name)">
                        <mat-icon>search</mat-icon>
                    </button>
                    <mat-error *ngIf="f[field.db_column_name].errors?.required">
                        {{ field.field_name }} is required.
                    </mat-error>
                </mat-form-field>
                <div *ngSwitchCase="'DROPDOWN'">
                    <mat-form-field appearance="legacy" *ngIf="field.is_autocomplete != 1" [style.width.%]="100">
                        <mat-label for="{field.db_column_name}">
                            {{ field.field_name }}
                            <span *ngIf="field.is_mandatory == 1" class="field-mandatory">*</span>
                        </mat-label>
                        <mat-select [formControlName]="field.db_column_name" (click)="searchText.focus()"
                            (focus)="searchText.focus()" (closed)="searchText.value=''"
                            (selectionChange)="changeDropdownFieldValue(field)" [id]="field.db_column_name">
                            <input (keydown)="$event.stopPropagation()" type="search" #searchText autocomplete="off"
                                class="mat-select-search" placeholder="Search {{field.field_name}}">
                            <mat-option [value]="option.id"
                                *ngFor="let option of field.options | listFilter:{'name':searchText.value}">
                                {{ option.name }}
                            </mat-option>
                        </mat-select>
                        <button *ngIf="field.is_magnify_search == 1" mat-button matSuffix mat-icon-button
                            (click)="$event.stopPropagation();openAdvanceSearchModal(field.field_mapping_detail_id,field.magnify_dependant_fields)">
                            <mat-icon>search</mat-icon>
                        </button>
                        <mat-error *ngIf="f[field.db_column_name].errors?.required">
                            {{ field.field_name }} is required.
                        </mat-error>
                    </mat-form-field>

                    <app-autocomplete matInput *ngIf="field.is_autocomplete == 1" [field]="field"
                        [formControlName]="field.db_column_name" [defaultValue]="field.field_v"
                        (callOnAutoCompleteChangedEvent)="callOnAutoCompleteChangedEvent(field)">
                    </app-autocomplete>
                </div>

                <mat-form-field *ngSwitchCase="'DATE'" [style.width.%]="100">
                    <mat-label for="{field.db_column_name}">
                        {{ field.field_name }}
                        <span *ngIf="field.is_mandatory == 1" class="field-mandatory">*</span>
                    </mat-label>
                    <input matInput readonly [id]="field.db_column_name" [min]="commonService.minDate"
                        [formControlName]="field.db_column_name" [matDatepicker]="picker"
                        (keydown.enter)="submitInvoice()" />
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    <mat-error *ngIf="f[field.db_column_name].errors?.required">
                        {{ field.field_name }} is required.
                    </mat-error>
                </mat-form-field>

                <div *ngSwitchCase="'FILE'" [style.width.%]="100">
                    <mat-hint align="end">
                        Valid Files:{{invoiceDocValidFileExtensions.join('/ ')}} | Max.
                        Size:
                        {{invoiceDocFileSize}}MB
                    </mat-hint>
                    <span class="text-danger">*</span>
                    <mat-toolbar (click)="invFileUpload_data.click()">
                        <div class="form-group">
                            <div class="input-group">
                                <input type="text" class="form-control fileuploadinput"
                                    [formControlName]="field.db_column_name" readonly>
                                <div class="input-group-btn">
                                    <span class="fileUpload btn blueupload">
                                        <span class="upl" id="upload">Upload Invoice
                                        </span>
                                        <input [attr.type]="fileControlType" class="upload up" id="up"
                                            #invFileUpload_data hidden />
                                        <!-- (change)="onSelectExcelFile($event)" -->

                                    </span>
                                </div>
                            </div>
                        </div>
                    </mat-toolbar>
                </div>

                <mat-form-field *ngSwitchCase="'TEXTAREA'" [style.width.%]="100">
                    <mat-label for="{field.db_column_name}">
                        {{ field.field_name }}
                        <span *ngIf="field.is_mandatory == 1" class="field-mandatory">*</span>
                    </mat-label>
                    <textarea matInput #fieldComments [formControlName]="field.db_column_name" rows="3" maxlength="500"
                        (change)="changeTextFieldValue(field)" [id]="field.db_column_name"></textarea>
                    <mat-hint align="end">
                        maximum {{ fieldComments.value?.length || 0 }} /500 charactors
                    </mat-hint>
                    <mat-error *ngIf="f[field.db_column_name].errors?.required">
                        {{ field.field_name }} is required.
                    </mat-error>
                </mat-form-field>

                <div *ngSwitchCase="'CHECKBOX'" [style.width.%]="100">
                    <mat-checkbox [formControlName]="field.db_column_name">
                        {{ field.field_name }}
                    </mat-checkbox>
                </div>
            </div>
        </div>



        <div class="row mt_20">
            <div class="col-lg-4 text-right"></div>
            <div class="col-lg-4"></div>

            <div class="col-lg-4 text-right">
                <button type="button" class="btncss me-2 btn_secondary" (click)="onResetButtonClick()">
                    Reset
                </button>
                <button class="btncss" [class.btn_disable]="frmInvoice?.invalid"
                    [class.btn_primary]="!frmInvoice?.invalid" [disabled]="frmInvoice?.invalid"
                    (click)="submitInvoice()">Search</button>
            </div>
        </div>


    </div>

</div>